import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	all: null,
	activeIds: [],
};

const objectLanguagesSlice = createSlice({
	name: 'objectLanguages',
	initialState,
	reducers: {
		setObjectLanguages: (state, action) => {
			if (action.payload) {
				state.all = action.payload.objectLanguages;
				state.activeIds = Object.keys(action.payload.objectLanguages);
			}
		},
		resetObjectLanguages: (state) => {
			state.all = initialState.all;
			state.activeIds = initialState.activeIds;
		},
	},
});

export default objectLanguagesSlice.reducer;
export const { setObjectLanguages, resetObjectLanguages } = objectLanguagesSlice.actions;

export const selectActiveObjectLanguageIdsForAPI = (state) => `[${state.objectLanguages.activeIds.map((langId) => `"${langId}"`).join(',')}]`;

export const selectObjectLanguageById = (state, objectLanguageId) => state.objectLanguages.all?.[objectLanguageId];
